import { TFunction } from "i18next";
import { z } from "zod";
import { getUpdateUserFormSchema } from "./UpdateUserForm";

export const getUpdateUserProfileFormSchema = (t: TFunction) =>
  getUpdateUserFormSchema(t).omit({
    roleId: true,
    enabled: true,
  });

export type UpdateUserForm = z.infer<ReturnType<typeof getUpdateUserFormSchema>>;
export type UpdateUserProfileForm = z.infer<
  ReturnType<typeof getUpdateUserProfileFormSchema>
>;
